// extracted by mini-css-extract-plugin
module.exports = {"FormTextEditor__label":"FormTextEditor_FormTextEditor__label__nvN8q"};